import { axiosInstance } from '.'
import { GET_JOB_SCHEDULE, RUN_JOB_SCHEDULE, UPDATE_JOB_SCHEDULE } from './endpoints'

export type JobScheduleFrequency = 'DAILY' | 'WEEKLY'
export type JobScheduleStatus = 'RUNNING' | 'SUCCEEDED' | 'FAILED'

/** Form values. daysOfWeek uses 0 (Sunday) to 6 (Saturday). */
export type JobScheduleFormData = {
  name: string
  enabled: boolean
  frequency: JobScheduleFrequency
  timeOfDay: string
  timezone: string
  daysOfWeek: number[]
}

/** Body sent to the server. daysOfWeek is null for daily schedules. */
export type JobScheduleUpdateData = Omit<JobScheduleFormData, 'daysOfWeek'> & {
  daysOfWeek: number[] | null
}

export type JobScheduleItem = Omit<JobScheduleFormData, 'daysOfWeek'> & {
  jobKey: string
  daysOfWeek: number[] | null
  nextRunAt: string | null
  lastRunAt: string | null
  lastStatus: JobScheduleStatus | null
  lastSucceededAt: string | null
}

export const jobScheduleServices = {
  getByJobKey: async (jobKey: string) => {
    try {
      const response = await axiosInstance.get(GET_JOB_SCHEDULE(jobKey))
      return response
    } catch (error: any) {
      return error.response
    }
  },

  update: async (jobKey: string, data: JobScheduleUpdateData) => {
    try {
      const response = await axiosInstance.put(UPDATE_JOB_SCHEDULE(jobKey), data)
      return response
    } catch (error: any) {
      return error.response
    }
  },

  /** Starts a run now. Responds 202 when started, 409 when a run is already in progress. */
  runNow: async (jobKey: string) => {
    try {
      const response = await axiosInstance.post(RUN_JOB_SCHEDULE(jobKey))
      return response
    } catch (error: any) {
      return error.response
    }
  },
}
